import {gzipString} from './gzipString'

// Сжимает строку с помощью gzip и кодирует в base64.
export async function gzipStringToBase64(str: string): Promise<string> {
    const compressed = await gzipString(str)
    return btoa(String.fromCharCode(...compressed))
}
